const css = `._0x4p6G__listComponent{margin:0;padding:8px 0;list-style:none}._0x4p6G__listComponent._0x4p6G__disablePadding{padding:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"listComponent":"_0x4p6G__listComponent","disablePadding":"_0x4p6G__disablePadding"};
